import { useMemo } from 'react';
import { CollapsibleCard } from "./CollapsibleCard";
import { friendlyRange } from "./compare/headlineTotals";
import { GadsHeader, HeadlineNumbers, SearchTerms, TopCampaigns } from "./google-ads/GoogleAdsParts";

export function GoogleAdsSection({ googleAdsData, story = null }) {
  const campaigns = googleAdsData?.campaigns || [];
  const summary = googleAdsData?.summary;
  const terms = googleAdsData?.search_terms || [];

  const dateRange = useMemo(() => {
    const starts = campaigns.map(c => c.report_start).filter(Boolean).sort();
    const ends = campaigns.map(c => c.report_end).filter(Boolean).sort();
    return starts.length && ends.length ? friendlyRange(starts[0], ends[ends.length - 1]) : '';
  }, [campaigns]);

  const top = useMemo(() => [...campaigns].sort((a, b) => (b.clicks || 0) - (a.clicks || 0)).slice(0, 3), [campaigns]);

  if (!summary || campaigns.length === 0) return null;

  return (
    <CollapsibleCard
      testId="google-ads-section"
      containerClass="rounded-2xl p-6 md:p-8 border border-[#b9dcff]/20 bg-gradient-to-br from-[#14305a]/70 via-[#0f2546]/60 to-[#0b1c36]/50"
      chevronClass="text-[#b9dcff]"
      hintClass="text-[#b9dcff]/70"
      header={<GadsHeader dateRange={dateRange} clicks={summary.total_clicks} />}
      story={story}
    >
      <HeadlineNumbers summary={summary} />
      {terms.length > 0 && <SearchTerms terms={terms} />}
      {top.length > 1 && <TopCampaigns campaigns={top} />}
    </CollapsibleCard>
  );
}
